var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.848924 1.57861L12.5023 13.0066L0.935591 24.5399C0.746832 24.2932 0.59998 24.0171 0.500924 23.7226C0.448911 23.3891 0.448911 23.0495 0.500924 22.7159V3.08928C0.466258 2.56261 0.587591 2.03594 0.847591 1.57861M17.5223 8.02261L13.7183 11.7906L2.20359 0.466609C2.57692 0.337275 2.97692 0.301275 3.36759 0.362609C3.98092 0.530609 4.56626 0.789275 5.10359 1.12661L15.5249 6.89328C16.2023 7.25728 16.8623 7.63994 17.5223 8.02261ZM13.7196 14.2399L17.5049 17.9573L14.7609 19.4853L6.38892 24.1386C5.69559 24.5213 4.99959 24.8866 4.32226 25.3039C4.0325 25.4845 3.7075 25.6012 3.36902 25.646C3.03054 25.6908 2.68638 25.6629 2.35959 25.5639L13.7196 14.2399ZM23.5329 13.0066C23.5434 13.473 23.4259 13.9333 23.1932 14.3376C22.9605 14.7419 22.6214 15.0747 22.2129 15.2999L19.0849 17.0359L14.9689 13.0066L19.1023 8.90794C20.1623 9.49861 21.2049 10.0893 22.2463 10.6453C22.6618 10.8772 23.0031 11.222 23.2306 11.64C23.458 12.0579 23.5638 12.5318 23.5329 13.0066Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPlaystore);
export default __webpack_public_path__ + "static/media/blackPlaystore.184a06246598f153b8b3f9b364edc745.svg";
export { ForwardRef as ReactComponent };